import { z } from 'zod'

export const StockBinLocationFormSchema = z.object({
  binLocation: z.string().nullable().optional(),
})

export type StockBinLocationFormValues = z.infer<typeof StockBinLocationFormSchema>
